import { Checkbox, FormControlLabel, Typography } from '@mui/material'
import { TemplateNodeSchema } from '@ulysses-inc/harami_api_client'

type Props = {
  node: TemplateNodeSchema
  isEmployeeCheck: boolean
  updateTemplateNode: (nodeId: number, changeNode: TemplateNodeSchema) => void
}

export const EmployeeMultipleSelectionCheckbox = ({
  node,
  isEmployeeCheck,
  updateTemplateNode,
}: Props) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          disabled={isEmployeeCheck}
          checked={node.question?.responseEmployees?.[0]?.isMultiple === 1}
          onClick={() => {
            updateTemplateNode(node.id, {
              ...node,
              question: {
                ...node.question,
                responseEmployees: [
                  {
                    templateQuestionId: node.question?.id,
                    subType: node.question?.responseEmployees?.[0]?.subType,
                    isMultiple:
                      node.question?.responseEmployees?.[0]?.isMultiple === 1
                        ? 0
                        : 1,
                  },
                ],
              },
            })
          }}
        />
      }
      label={<Typography variant="body2">複数名の選択を可能にする</Typography>}
    />
  )
}
